import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { ChronosphereColorPalette } from './colors';
import { primaryColor } from './status/primary';

export const primary = (mode: PaletteMode): SimplePaletteColorOptions & ChronosphereColorPalette => {
  const color = primaryColor(mode);
  return {
    ...color,
    // Use the high/low contrast versions instead. This is meant to backfill the MUI tokens.
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
